module.exports = __webpack_public_path__ + "static/media/dove-transparent.04d6973a.png";